import { WorkflowFieldType } from '~/enums/WorkflowFieldType';

export function filterOutDocumentPartFileFields(
  allOptions: { label: string; value: string }[],
  fields: Record<
    string,
    { type: string; customSettings?: Record<string, any> }
  >,
  isMultiDocEnabled: boolean,
  IS_DOCUMENT_PART_KEY: string,
) {
  if (!isMultiDocEnabled) return allOptions;

  return allOptions.filter((option) => {
    const field = fields[option.value];
    const customSettings = field?.customSettings;
    return !(
      field?.type === WorkflowFieldType.File &&
      customSettings?.[IS_DOCUMENT_PART_KEY] === true
    );
  });
}
